<div class="prom-button-group">
    <div class="prom-button-group__left">
        <slot />
    </div>
    <div class="prom-button-group__right">
        <slot name="right" />
    </div>
</div>
